
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightSnowShowersNight as ObiLightSnowShowersNightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-snow-showers-night.js';
 
 
 

 
 export const ObiLightSnowShowersNight = createComponent({
   react: React,
   tagName: 'obi-light-snow-showers-night',
   elementClass: ObiLightSnowShowersNightElement,
   events: {
     
   }
  });
 
 